import React from "react";
import { useState } from "react";
import { Typography, Divider, useMediaQuery } from "@mui/material";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/400.css";
import ExpandInfo from "./ExpandInfo";

const Step5Casnic = () => {
  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? 0 : "140px",
          marginRight: isMobile ? -20 : "140px",
          marginTop: isMobile ? -50 : "50px",
        }}
      >
        {!isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: isLaptop ? "17rem" : "15.5rem",
              width: "4px",
              backgroundColor: "#29348f",
            }}
          />
        ) : (
          ""
        )}
        <div style={{ marginLeft: 34 }}>
          <div
            style={{
              display: "flex",
              justifyContent: isMobile ? "flex-end" : "",
            }}
          >
            <div
              variant="contained"
              style={{
                backgroundColor: "#29348f",
                textTransform: "none",
                borderRadius: !isMobile ? "0" : "20px 0px 0px 20px",
                height: 40,
                width: !isMobile ? 230 : 70,
                paddingLeft: 14,
                paddingTop: 8,
              }}
            >
              <Typography variant="body1" color="white">
                {isMobile ? "DEER" : "Operator economic atestat"}
              </Typography>
            </div>
            <div
              variant="contained"
              style={{
                backgroundColor: "black",
                borderRadius: isMobile ? "0" : "0px 20px 20px 0px",
                textTransform: "none",
                height: 40,
                width: isMobile ? 180 : 80,
                paddingLeft: 14,
                paddingTop: 8,
              }}
            >
              <Typography variant="body1" color="white">
                {!isMobile ? "DEER" : "Op. economic atestat"}
              </Typography>
            </div>
          </div>
          <Typography variant="h6" sx={{ mt: 5 }}>
            Proiectarea/execuția instalației de racordare{" "}
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Se realizează: De către proiectantul/constructorul atestat, desemnat
            de către solicitant;
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            De către operatorul de distribuție, conform contractului de
            racordare.
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            În termenii agreați de comun acord în cadrul Contractului de
            Racordare
          </Typography>
        </div>
        {isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: "32rem",
              width: "4px",
              backgroundColor: "#29348f",
              ml: 2,
            }}
          />
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? -30 : "140px",
          marginTop: "50px",
          marginRight: isMobile ? 0 : "140px",
          marginBottom: "60px",
        }}
      >
        <Divider
          orientation="vertical"
          sx={{
            height: "4rem",
            width: "4px",
            backgroundColor: "#29348f",
            mr: isMobile ? 3 : "",
          }}
        />
        <ExpandInfo />
      </div>
    </div>
  );
};

export default Step5Casnic;
